import React, { useEffect, useState } from "react";
import { X, Trash2, Plus, Loader2 } from "lucide-react";
import { toast } from "sonner";
import useTier from "../../Sevices/useTier";

const TierBenefitsModal = ({
  tier,
  onClose,
  addTierBenefit,
  deleteTierBenefit,
  refreshBenefits,
}) => {
  const { FetchAllTierBenefits } = useTier();

  const [benefits, setBenefits] = useState([]);
  const [newBenefit, setNewBenefit] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [deletingId, setDeletingId] = useState(null);

  const tierId = tier?.tierId || tier?.id || "";

  // ===== FETCH BENEFITS =====
  const fetchBenefits = async () => {
    setLoading(true);
    try {
      // use hook API
      await FetchAllTierBenefits((map) => {
        const data = map[String(tierId)] || [];
        setBenefits(data);
      });
    } catch {
      toast.error("Error fetching benefits");
    } finally {
      setLoading(false);
    }
  };

  // ===== ADD =====
  const handleAddBenefit = async (e) => {
    e.preventDefault();

    if (!newBenefit.trim()) {
      toast.error("Please enter a benefit");
      return;
    }

    if (!tierId) {
      toast.error("Tier ID missing");
      return;
    }

    setSubmitting(true);

    await addTierBenefit(tierId, newBenefit, async () => {
      setNewBenefit("");
      await fetchBenefits();
      refreshBenefits?.();
    });

    setSubmitting(false);
  };

  // ===== DELETE =====
  const handleDeleteBenefit = async (benefitId) => {
    setDeletingId(benefitId);

    await deleteTierBenefit(benefitId, () => {
      setBenefits((prev) => prev.filter((b) => b.benefitId !== benefitId));
      refreshBenefits?.();
    });

    setDeletingId(null);
  };

  useEffect(() => {
    if (tierId) fetchBenefits();
  }, [tierId]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="relative w-11/12 max-w-2xl rounded-xl bg-slate-50 shadow-2xl border border-slate-200">
        {/* Header */}
        <div className="flex items-center justify-between border-b border-slate-200 px-5 py-4 bg-slate-100 rounded-t-xl">
          <div>
            <h3 className="text-lg font-semibold text-slate-900">
              {tier?.tier_title || "Tier Details"}
            </h3>
          </div>

          <button onClick={onClose} className="p-2">
            <X size={18} />
          </button>
        </div>

        {/* Body */}
        <div className="px-5 py-4 space-y-4">
          {/* ADD */}
          <form onSubmit={handleAddBenefit} className="flex gap-2">
            <input
              value={newBenefit}
              onChange={(e) => setNewBenefit(e.target.value)}
              className="flex-1 border px-3 py-2"
            />

            <button disabled={submitting}>
              {submitting ? <Loader2 className="animate-spin" /> : <Plus />}
            </button>
          </form>

          {/* LIST */}
          {loading ? (
            <Loader2 className="animate-spin" />
          ) : (
            benefits.map((b) => (
              <div key={b.benefitId} className="flex justify-between">
                <span>{b.benefit}</span>

                <button onClick={() => handleDeleteBenefit(b.benefitId)}>
                  {deletingId === b.benefitId ? (
                    <Loader2 className="animate-spin" />
                  ) : (
                    <Trash2 />
                  )}
                </button>
              </div>
            ))
          )}
        </div>

        {/* Footer */}
        <div className="p-4 text-right">
          <button onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default TierBenefitsModal;
